import { createAction } from "@reduxjs/toolkit";
import { SurveysAnswer } from "../../../domain/survey/survey.types";

const SURVEY_ACTION = "survey";

export const surveysActions = {
  getSurveysByProjectRequested: createAction<string | undefined>(
    `${SURVEY_ACTION}/getSurveysByProject`,
  ),
  getSurveysByProjectInProgress: createAction(
    `${SURVEY_ACTION}/getSurveysByProjectInProgress`,
  ),
  getSurveysByProjectDone: createAction(
    `${SURVEY_ACTION}/getSurveysByProjectDone`,
  ),
  loadSurveysAnswersRequested: createAction<SurveysAnswer>(
    `${SURVEY_ACTION}/loadSurveysAnswersRequested`,
  ),
  loadSurveysAnswersEnd: createAction(`${SURVEY_ACTION}/loadSurveysAnswersEnd`),

  resumeSurveyFromStateRequested: createAction<{
    surveyID: string;
    questionID: string;
  }>(`${SURVEY_ACTION}/resumeSurveyFromStateRequested`),
  resumeSurveyFromStateDone: createAction(
    `${SURVEY_ACTION}/resumeSurveyFromStateDone`,
  ),

  getSurveyByIdRequested: createAction<{
    surveyID: string;
    order: number;
  }>(`${SURVEY_ACTION}/getSurveyByIdRequested`),
  getSurveyByIdInProgress: createAction(
    `${SURVEY_ACTION}/getSurveyByIdInProgress`,
  ),
  getSurveyByIdDone: createAction(`${SURVEY_ACTION}/getSurveyByIdDone`),

  getQuestionsBySurveyRequested: createAction<string>(
    `${SURVEY_ACTION}/getQuestionsBySurvey`,
  ),
  getQuestionsBySurveyInProgress: createAction(
    `${SURVEY_ACTION}/getQuestionsBySurveyInProgress`,
  ),
  getQuestionsBySurveyDone: createAction(
    `${SURVEY_ACTION}/getQuestionsBySurveyDone`,
  ),
};
